import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "style", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Children, useEffect, useId, useMemo, useRef, useState } from 'react';
import { useTheme } from '../Flowbite/ThemeContext';
import { TabItem } from './TabItem';
export var TabsComponent = function TabsComponent(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'default' : _ref$style,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme().theme.tab;
  var id = useId();
  var tabs = useMemo(function () {
    return Children.map(children, function (_ref2) {
      var props = _ref2.props;
      return props;
    });
  }, [children]);
  var tabRefs = useRef([]);
  var _useState = useState(Math.max(0, tabs.findIndex(function (tab) {
      return tab.active;
    }))),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useState3 = useState(Math.max(0, tabs.findIndex(function (tab) {
      return tab.active;
    }))),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedTab = _useState4[0],
    setFocusedTab = _useState4[1];
  var handleClick = function handleClick(_ref3) {
    var target = _ref3.target;
    setActiveTab(target);
    setFocusedTab(target);
  };
  var handleKeyboard = function handleKeyboard(_ref4) {
    var event = _ref4.event,
      target = _ref4.target;
    if (event.key === 'ArrowLeft') {
      setFocusedTab(Math.max(0, focusedTab - 1));
    }
    if (event.key === 'ArrowRight') {
      setFocusedTab(Math.min(tabs.length - 1, focusedTab + 1));
    }
    if (event.key === 'Enter') {
      setActiveTab(target);
      setFocusedTab(target);
    }
  };
  var tabItemStyle = theme.tablist.tabitem.styles[style];
  useEffect(function () {
    var _tabRefs$current$focu;
    (_tabRefs$current$focu = tabRefs.current[focusedTab]) === null || _tabRefs$current$focu === void 0 ? void 0 : _tabRefs$current$focu.focus();
  }, [focusedTab]);
  return _jsxs("div", {
    className: classNames(theme.base, className),
    children: [_jsx("div", _objectSpread(_objectSpread({
      "aria-label": "Tabs",
      role: "tablist",
      className: classNames(theme.tablist.base, theme.tablist.styles[style], className)
    }, rest), {}, {
      children: tabs.map(function (tab, index) {
        var _classNames;
        return _jsxs("button", {
          type: "button",
          "aria-controls": "".concat(id, "-tabpanel-").concat(index),
          "aria-selected": index === activeTab,
          className: classNames(theme.tablist.tabitem.base, _objectSpread({}, tabItemStyle), (_classNames = {}, _defineProperty(_classNames, tabItemStyle.active.on, index === activeTab), _defineProperty(_classNames, tabItemStyle.active.off, index !== activeTab && !tab.disabled), _classNames)),
          disabled: tab.disabled,
          id: "".concat(id, "-tab-").concat(index),
          onClick: function onClick() {
            return handleClick({
              target: index
            });
          },
          onKeyDown: function onKeyDown(event) {
            return handleKeyboard({
              event: event,
              target: index
            });
          },
          ref: function ref(element) {
            return tabRefs.current[index] = element;
          },
          role: "tab",
          tabIndex: index === focusedTab ? 0 : -1,
          children: [tab.icon && _jsx(tab.icon, {
            className: theme.tablist.tabitem.icon
          }), tab.title]
        }, index);
      })
    })), _jsx("div", {
      children: tabs.map(function (tab, index) {
        return _jsx("div", {
          "aria-labelledby": "".concat(id, "-tab-").concat(index),
          className: theme.tabpanel,
          hidden: index !== activeTab,
          id: "".concat(id, "-tabpanel-").concat(index),
          role: "tabpanel",
          tabIndex: 0,
          children: tab.children
        }, index);
      })
    })]
  });
};
TabsComponent.displayName = 'Tabs.Group';
TabItem.displayName = 'Tabs.Item';
export var Tabs = {
  Group: TabsComponent,
  Item: TabItem
};